export default __webpack_public_path__ + "static/owner_policies-96a1b3dfce925a8240f79daacab91d4d.svg";